import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "\u0422\u043E\u04B7\u0438\u043A\u04E3",
  code: "tj",
  messages: {
    alert: {
      close: "\u0411\u0430\u0441\u0442\u0430\u043D"
    },
    authForm: {
      hidePassword: "\u041F\u0438\u043D\u04B3\u043E\u043D \u043A\u0430\u0440\u0434\u0430\u043D\u0438 \u043F\u0430\u0440\u043E\u043B",
      showPassword: "\u041D\u0430\u043C\u043E\u0438\u0448\u0438 \u043F\u0430\u0440\u043E\u043B",
      submit: "\u0418\u0434\u043E\u043C\u0430 \u0434\u043E\u0434\u0430\u043D"
    },
    banner: {
      close: "\u041F\u04EF\u0448\u0438\u0434\u0430\u043D"
    },
    calendar: {
      nextMonth: "\u041C\u043E\u04B3\u0438 \u043E\u044F\u043D\u0434\u0430",
      nextYear: "\u0421\u043E\u043B\u0438 \u043E\u044F\u043D\u0434\u0430",
      prevMonth: "\u041C\u043E\u04B3\u0438 \u0433\u0443\u0437\u0430\u0448\u0442\u0430",
      prevYear: "\u0421\u043E\u043B\u0438 \u0433\u0443\u0437\u0430\u0448\u0442\u0430"
    },
    carousel: {
      dots: "\u0421\u043B\u0430\u0439\u0434\u0440\u043E \u0431\u0430\u0440\u043E\u0438 \u043D\u0430\u043C\u043E\u0438\u0448 \u0438\u043D\u0442\u0438\u0445\u043E\u0431 \u043A\u0443\u043D\u0435\u0434",
      goto: "\u0411\u0430 \u0441\u043B\u0430\u0439\u0434\u0438 {slide} \u0433\u0443\u0437\u0430\u0440\u0435\u0434",
      next: "\u0411\u0430\u044A\u0434\u04E3",
      prev: "\u049A\u0430\u0431\u043B\u04E3"
    },
    chatPrompt: {
      placeholder: "\u041F\u0430\u0439\u0451\u043C \u0432\u043E\u0440\u0438\u0434 \u043A\u0443\u043D\u0435\u0434..."
    },
    chatPromptSubmit: {
      label: "\u0424\u0438\u0440\u0438\u0441\u0442\u043E\u0434\u0430\u043D"
    },
    colorMode: {
      dark: "\u0422\u043E\u0440\u0438\u043A",
      light: "\u0420\u04EF\u0448\u043D\u043E",
      switchToDark: "\u0413\u0443\u0437\u0430\u0440\u0438\u0448 \u0431\u0430 \u04B3\u043E\u043B\u0430\u0442\u0438 \u0442\u043E\u0440\u0438\u043A",
      switchToLight: "\u0413\u0443\u0437\u0430\u0440\u0438\u0448 \u0431\u0430 \u04B3\u043E\u043B\u0430\u0442\u0438 \u0440\u04EF\u0448\u043D\u043E",
      system: "\u0421\u0438\u0441\u0442\u0435\u043C\u0430"
    },
    commandPalette: {
      back: "\u0411\u043E\u0437\u0433\u0430\u0448\u0442",
      close: "\u0411\u0430\u0441\u0442\u0430\u043D",
      noData: "\u041C\u0430\u044A\u043B\u0443\u043C\u043E\u0442 \u043D\u0435\u0441\u0442",
      noMatch: "\u041C\u0430\u044A\u043B\u0443\u043C\u043E\u0442\u0438 \u043C\u0443\u0432\u043E\u0444\u0438\u049B \u0451\u0444\u0442 \u043D\u0430\u0448\u0443\u0434",
      placeholder: "\u0424\u0430\u0440\u043C\u043E\u043D\u0440\u043E \u043D\u0430\u0432\u0438\u0441\u0435\u0434 \u0451 \u04B7\u0443\u0441\u0442\u0443\u04B7\u04EF \u043A\u0443\u043D\u0435\u0434..."
    },
    contentSearch: {
      links: "\u041F\u0430\u0439\u0432\u0430\u043D\u0434\u04B3\u043E",
      theme: "\u041C\u0430\u0432\u0437\u04EF\u044A"
    },
    contentSearchButton: {
      label: "\u04B6\u0443\u0441\u0442\u0443\u04B7\u04EF"
    },
    contentToc: {
      title: "\u041C\u0443\u043D\u0434\u0430\u0440\u0438\u04B7\u0430"
    },
    dashboardSearch: {
      theme: "\u041C\u0430\u0432\u0437\u04EF\u044A"
    },
    dashboardSearchButton: {
      label: "\u04B6\u0443\u0441\u0442\u0443\u04B7\u04EF"
    },
    dashboardSidebarCollapse: {
      collapse: "\u041A\u0430\u043C \u043A\u0430\u0440\u0434\u0430\u043D",
      expand: "\u0412\u0430\u0441\u0435\u044A \u043A\u0430\u0440\u0434\u0430\u043D"
    },
    dashboardSidebarToggle: {
      close: "\u041F\u04EF\u0448\u0438\u0434\u0430\u043D",
      open: "\u041A\u0443\u0448\u043E\u0434\u0430\u043D"
    },
    error: {
      clear: "\u0422\u043E\u0437\u0430 \u043A\u0430\u0440\u0434\u0430\u043D"
    },
    fileUpload: {
      removeFile: "{filename}-\u0440\u043E \u0445\u043E\u0440\u0438\u04B7 \u043A\u0443\u043D\u0435\u0434"
    },
    header: {
      close: "\u041F\u04EF\u0448\u0438\u0434\u0430\u043D",
      open: "\u041A\u0443\u0448\u043E\u0434\u0430\u043D"
    },
    inputMenu: {
      create: '"{label}" \u0441\u043E\u0437\u0435\u0434',
      noData: "\u041C\u0430\u044A\u043B\u0443\u043C\u043E\u0442 \u043D\u0435\u0441\u0442",
      noMatch: "\u041C\u0430\u044A\u043B\u0443\u043C\u043E\u0442\u0438 \u043C\u0443\u0432\u043E\u0444\u0438\u049B \u0451\u0444\u0442 \u043D\u0430\u0448\u0443\u0434"
    },
    inputNumber: {
      decrement: "\u041A\u0430\u043C \u043A\u0430\u0440\u0434\u0430\u043D",
      increment: "\u0417\u0438\u0451\u0434 \u043A\u0430\u0440\u0434\u0430\u043D"
    },
    modal: {
      close: "\u0411\u0430\u0441\u0442\u0430\u043D"
    },
    pricingTable: {
      caption: "\u04B6\u0430\u0434\u0432\u0430\u043B\u0438 \u043D\u0430\u0440\u0445\u04B3\u043E"
    },
    prose: {
      codeCollapse: {
        closeText: "\u041A\u0430\u043C \u043A\u0430\u0440\u0434\u0430\u043D",
        name: "\u043A\u043E\u0434",
        openText: "\u0412\u0430\u0441\u0435\u044A \u043A\u0430\u0440\u0434\u0430\u043D"
      },
      collapsible: {
        closeText: "\u041F\u0438\u043D\u04B3\u043E\u043D \u043A\u0430\u0440\u0434\u0430\u043D",
        name: "\u0445\u0443\u0441\u0443\u0441\u0438\u044F\u0442\u04B3\u043E",
        openText: "\u041D\u0430\u043C\u043E\u0438\u0448 \u0434\u043E\u0434\u0430\u043D"
      },
      pre: {
        copy: "\u041D\u0443\u0441\u0445\u0430 \u0431\u0430\u0440\u0434\u043E\u0448\u0442\u0430\u043D"
      }
    },
    selectMenu: {
      create: '"{label}" \u0441\u043E\u0437\u0435\u0434',
      noData: "\u041C\u0430\u044A\u043B\u0443\u043C\u043E\u0442 \u043D\u0435\u0441\u0442",
      noMatch: "\u041C\u0430\u044A\u043B\u0443\u043C\u043E\u0442\u0438 \u043C\u0443\u0432\u043E\u0444\u0438\u049B \u0451\u0444\u0442 \u043D\u0430\u0448\u0443\u0434",
      search: "\u04B6\u0443\u0441\u0442\u0443\u04B7\u04EF..."
    },
    slideover: {
      close: "\u0411\u0430\u0441\u0442\u0430\u043D"
    },
    table: {
      noData: "\u041C\u0430\u044A\u043B\u0443\u043C\u043E\u0442 \u043D\u0435\u0441\u0442"
    },
    toast: {
      close: "\u0411\u0430\u0441\u0442\u0430\u043D"
    }
  }
});
